<!-- 快捷键 -->
<template>
  <span class="shortcutKeyTip_c">
    <img src="/static/btn/pingzheng_kuaijiejian.png" alt="快捷键操作" title="快捷键操作" v-popover:shortcutPop>
    <el-popover ref="shortcutPop" trigger="hover" title="" width="360" placement="bottom">
    	<div class="shortcutKeyTip_c-popover">
        <template v-for="(item,index) in dataList">
          <div :key="index">
            <h4>{{ item.title }}</h4>
            <el-row class="shortcutKeyTip_c-popover-row">
              <template v-for="(i,index) in item.list">
                <el-col :span="12" class="shortcutKeyTip_c-popover-row-col">{{ i.key }}</el-col>
                <el-col :span="12" class="shortcutKeyTip_c-popover-row-col">{{ i.discribe }}</el-col>
              </template>
            </el-row>
          </div>
        </template>
    	</div>
    </el-popover>
  </span>
</template>

<script>
  export default{
    props:{
      dataList:{
        type:Array,
        default:()=>{
          return [
            {
              title:"保存新增",
              list:[
                {
                  key:"Ctrl + s",
                  discribe:"保存"
                },
                {
                  key:"F12",
                  discribe:"保存并新增"
                },
                {
                  key:"F9",
                  discribe:"新增"
                }
              ]
            },
            {
              title:"快捷操作",
              list:[
                {
                  key:"Enter(输入后)",
                  discribe:"录入下一个字段"
                },
                {
                  key:"Tab",
                  discribe:"光标跳转到下一个输入框"
                },
                {
                  key:"shift + Tab",
                  discribe:"光标跳转到上一个输入框"
                },
              ]
            },
            {
              title:"切换",
              list:[
                {
                  key:"Ctrl + 1",
                  discribe:"收入"
                },
                {
                  key:"Ctrl + 2",
                  discribe:"支出"
                },
                {
                  key:"Ctrl + 3",
                  discribe:"内部转账"
                }
              ]
            }
          ]
        }
      }
    }
  }
</script>

<style lang="less">
  .shortcutKeyTip_c {
    &-popover {
      h4 {
        border-bottom: 1px solid #ddd;
        padding: 5px 0;
        margin-bottom: 10px;
      }
      &-row {
        &-col {
          margin-bottom: 10px;
        }
      }
    }
    img {
      width: 20px;
      height: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/attr/shortcutKeyTip.vue